<template lang="pug">
b-modal#addBankAccount(
  ref="addBankAccount"
  :title="$t('ui.combine.add_bank_account')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.banks', 1)").mb-0
      BankLookup(
        ref="bank"
        :bankStatus="null"
        size="sm"
        required
        type="array"
        :dirty="$v.bank.$dirty"
        :error="$v.bank.$error"
        v-model.trim.lazy="$v.bank.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
    b-form-group(:label="$t('ui.bank_acc_no')").mb-0
      DebounceInput(
        size="sm"
        required
        type="text"
        :dirty="$v.bank_acc_no.$dirty"
        :error="$v.bank_acc_no.$error"
        v-model.trim.lazy="$v.bank_acc_no.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')")
    b-form-group(:label="$tc('ui.bank_acc_holder')").mb-0
      DebounceInput(
        size="sm"
        required
        type="text"
        :dirty="$v.bank_acc_holder.$dirty"
        :error="$v.bank_acc_holder.$error"
        v-model.trim.lazy="$v.bank_acc_holder.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_holder" :name="$t('ui.bank_acc_holder')")
    b-form-group(:label="$t('ui.bank_acc_type')").mb-0
      BankAccType(
        size="sm"
        required
        type="array"
        :dirty="$v.bank_acc_type.$dirty"
        :error="$v.bank_acc_type.$error"
        v-model.trim.lazy="$v.bank_acc_type.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_type" :name="$t('ui.bank_acc_type')")
    b-form-group(:label="$tc('ui.account_balance')").mb-0
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.account_balance.$dirty"
        :error="$v.account_balance.$error"
        v-model.trim.lazy="$v.account_balance.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.account_balance" :name="$t('ui.account_balance')")
    template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
      b-form-group(:label="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')")
      template(v-if="['AUD'].includes(getCurrencyCode)")
        b-form-group(:label="$t('ui.payid')").mb-0
          DebounceInput(
            size="sm"
            required
            type="text"
            :dirty="$v.remark_2.$dirty"
            :error="$v.remark_2.$error"
            v-model.trim.lazy="$v.remark_2.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.remark_2" :name="$t('ui.payid')")
    //- b-form-group(:label="$t('ui.bank_group')").mb-0
    //-   BankGroupLookup(
    //-     ref="bank_group"
    //-     size="sm"
    //-     required
    //-     type="array"
    //-     :dirty="$v.bank_group.$dirty"
    //-     :error="$v.bank_group.$error"
    //-     v-model.trim.lazy="$v.bank_group.$model"
    //-     :disabled="loading"
    //-   )
    //-   ValidateResult(:value="$v.bank_group" :name="$t('ui.bank_group')")
    //- b-form-group(:label="$t('ui.is_public')").mb-2
    //-   div.d-flex
    //-     label.custom-switch
    //-       input.custom-switch-input(
    //-         type="checkbox"
    //-         name='custom-switch-checkbox'
    //-         required
    //-         :dirty="$v.is_public.$dirty"
    //-         :error="$v.is_public.$error"
    //-         v-model.trim.lazy="$v.is_public.$model"
    //-         :disabled="loading"
    //-       )
    //-       span.custom-switch-indicator
    div
      b-form-group(:label="$t('ui.threshold')").mb-3
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover
            thead.thead-light
              tr
                th(width="20%")
                  span &nbsp;
                th.text-right(width="30%")
                  span {{ $t('ui.amount') }}
                th.text-right(width="50%")
                  span {{ $t('ui.frequency') }}
            tbody
              tr(v-if="bank_acc_type.toUpperCase() != 'OUTGOING'")
                td
                  span.font-weight-bold.text-uppercase {{ $t('ui.incoming') }}
                td
                  DebounceInput.text-right(
                    size="sm"
                    ref="incoming_amount_threshold"
                    required
                    type="text"
                    :dirty="$v.incoming_amount_threshold.$dirty"
                    :error="$v.incoming_amount_threshold.$error"
                    v-model.trim.lazy="$v.incoming_amount_threshold.$model"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.incoming_amount_threshold" :name="$t('ui.incoming_amount_threshold')")
                td
                  DebounceInput.text-right(
                    size="sm"
                    ref="incoming_frequency_threshold"
                    required
                    type="text"
                    :dirty="$v.incoming_frequency_threshold.$dirty"
                    :error="$v.incoming_frequency_threshold.$error"
                    v-model.trim.lazy="$v.incoming_frequency_threshold.$model"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.incoming_frequency_threshold" :name="$t('ui.frequency')")
              tr(v-if="bank_acc_type.toUpperCase() != 'INCOMING'")
                td
                  span.font-weight-bold.text-uppercase {{ $t('ui.outgoing') }}
                td
                  DebounceInput.text-right(
                    size="sm"
                    ref="outgoing_amount_threshold"
                    required
                    type="text"
                    :dirty="$v.outgoing_amount_threshold.$dirty"
                    :error="$v.outgoing_amount_threshold.$error"
                    v-model.trim.lazy="$v.outgoing_amount_threshold.$model"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.outgoing_amount_threshold" :name="$t('ui.outgoing_amount_threshold')")
                td
                  DebounceInput.text-right(
                    size="sm"
                    ref="outgoing_frequency_threshold"
                    required
                    type="text"
                    :dirty="$v.outgoing_frequency_threshold.$dirty"
                    :error="$v.outgoing_frequency_threshold.$error"
                    v-model.trim.lazy="$v.outgoing_frequency_threshold.$model"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.outgoing_frequency_threshold" :name="$t('ui.frequency')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankLookup from "@/library/BankLookupNew";
// import BankGroupLookup from "@/library/BankGroupLookup";
import BankAccType from "@/library/BankAccType";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankLookup,
    BankAccType,
    // BankGroupLookup
  },
  props: {
    // item: {
    //   type: Object,
    //   default: {}
    // },
  },
  data() {
    return {
      bank: "",
      bank_acc_no: "",
      bank_acc_holder: "",
      bank_acc_type: "BOTH",
      // bank_group: "",
      account_balance: 0,
      // is_public: true,
      incoming_amount_threshold: 0,
      incoming_frequency_threshold: 0,
      outgoing_amount_threshold: 0,
      outgoing_frequency_threshold: 0,
      remark: "",
      remark_2: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  validations: {
    bank: {
      required
    },
    bank_acc_no: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(50),
      validBankAccFormat: function(value) {
        if (!value) return false // Required check
        if (this.bank === 'GATEWAY - PAYMENT GATEWAY') {
          return /^[a-zA-Z0-9]+$/.test(value)
        } else {
          return /^\d+$/.test(value)
        }
      }
    },
    bank_acc_holder: {
      required,
      alphaNumWithSpace,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    bank_acc_type: {
      required
    },
    // bank_group: {
    //   required
    // },
    // is_public: {
    //   required
    // },
    account_balance: {
      decimal,
      required,
    },
    incoming_amount_threshold: {
      decimal,
      required : requiredIf(function () {
        return this.bank_acc_type.toUpperCase() != 'OUTGOING';
      })
    },
    incoming_frequency_threshold: {
      integer,
      maxValue: maxValue(config.intMaxValue),
      required : requiredIf(function () {
        return this.bank_acc_type.toUpperCase() != 'OUTGOING';
      })
    },
    outgoing_amount_threshold: {
      decimal,
      required : requiredIf(function () {
        return this.bank_acc_type.toUpperCase() != 'INCOMING';
      })
    },
    outgoing_frequency_threshold: {
      integer,
      maxValue: maxValue(config.intMaxValue),
      required : requiredIf(function () {
        return this.bank_acc_type.toUpperCase() != 'INCOMING';
      })
    },
    remark: {
      required : requiredIf(function () {
        return ['ARS','AUD'].includes(this.getCurrencyCode);
      })
    },
    remark_2: {
      required : requiredIf(function () {
        return ['AUD'].includes(this.getCurrencyCode);
      })
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.bankAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          bank_id: this.bank.split(' - ')[0].trim(),
          bank_acc_no: this.bank_acc_no.trim(),
          bank_acc_holder: this.bank_acc_holder,
          bank_acc_type: this.bank_acc_type,
          incoming_amount_threshold: this.incoming_amount_threshold ? this.incoming_amount_threshold : 0.00,
          incoming_frequency_threshold: this.incoming_frequency_threshold ? this.incoming_frequency_threshold : 0,
          outgoing_amount_threshold: this.outgoing_amount_threshold ? this.outgoing_amount_threshold : 0.00,
          outgoing_frequency_threshold: this.outgoing_frequency_threshold ? this.outgoing_frequency_threshold : 0,
          remark: this.remark,
          remark_2: this.remark_2,
          account_balance: this.account_balance,
          
          // bank_group_id: this.bank_group,
          // is_public: this.is_public,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addBankAccount.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_bank_account", this.feedback.status);
                  this.$refs.addBankAccount.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.bank = "";
      this.bank_acc_no = "";
      this.bank_acc_holder = "";
      this.bank_acc_type = "BOTH";
      // this.bank_group = "";
      this.account_balance = 0;
      // this.is_public = true;
      this.incoming_amount_threshold = 0;
      this.incoming_frequency_threshold = 0;
      this.outgoing_amount_threshold = 0;
      this.outgoing_frequency_threshold = 0;
      this.feedback.success = true;
      this.feedback.status = "";
      this.remark = ""
      this.remark_2 = ""
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.bank.$el.focus();
    }
  }
};
</script>
